import {ARBaseComponent} from '@relayter/core';
import {AppConstants} from '../../app.constants';
import {DestroyRef, inject} from '@angular/core';

export abstract class RLBaseComponent extends ARBaseComponent {
    public permissions = AppConstants.PERMISSIONS;
    protected destroyRef: DestroyRef = inject(DestroyRef);
}
